import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Card, Col, Form, Row } from 'react-bootstrap';
import cx from 'classnames';

import s from './LocationServiceSettings.css';
import messages from '../../../../locale/messages';
import Link from '../../../Link';
import Loader from '../../../Common/Loader';
import { updateLocationServiceSetting } from '../../../../actions/siteadmin/Location/updateLocationServiceSetting';
import { FaBackward, FaChevronLeft } from 'react-icons/fa';

const SERVICE_GROUPS = [
    {
        titleKey: 'foodBooking',
        descKey: 'foodBookingDesc',
        services: [
            { key: 'isFoodDeliveryEnabled', labelKey: 'enableDelivery' },
            { key: 'isFoodSelfPickupEnabled', labelKey: 'enableSelfPickup' },
        ],
    },
    {
        titleKey: 'groceryBooking',
        descKey: 'groceryBookingDesc',
        services: [
            { key: 'isGroceryDeliveryEnabled', labelKey: 'enableDelivery' },
            { key: 'isGrocerySelfPickupEnabled', labelKey: 'enableSelfPickup' },
        ],
    },
    {
        titleKey: 'rideHailingBooking',
        descKey: 'rideHailingBookingDesc',
        services: [
            { key: 'isRideEnabled', labelKey: 'enableRide' },
        ],
    },
];

class LocationServiceSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFoodDeliveryEnabled: true,
            isFoodSelfPickupEnabled: true,
            isGroceryDeliveryEnabled: true,
            isGrocerySelfPickupEnabled: true,
            isRideEnabled: true,
            locationName: null,
            saving: false,
        };
        this.handleToggle = this.handleToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { settingData } = this.props;
        if (
            settingData !== prevProps.settingData &&
            settingData?.getLocationServiceSetting?.result
        ) {
            const r = settingData.getLocationServiceSetting.result;
            this.setState({
                locationName: r.locationName,
                isFoodDeliveryEnabled: r.isFoodDeliveryEnabled,
                isFoodSelfPickupEnabled: r.isFoodSelfPickupEnabled,
                isGroceryDeliveryEnabled: r.isGroceryDeliveryEnabled,
                isGrocerySelfPickupEnabled: r.isGrocerySelfPickupEnabled,
                isRideEnabled: r.isRideEnabled,
            });
        }
    }

    handleToggle(key) {
        this.setState(prev => ({ [key]: !prev[key] }));
    }

    async handleSubmit(e) {
        e.preventDefault();
        const { updateLocationServiceSetting, locationId } = this.props;
        const { saving, locationName, ...settings } = this.state;

        this.setState({ saving: true });
        await updateLocationServiceSetting(locationId, settings);
        this.setState({ saving: false });
    }

    render() {
        const { settingData } = this.props;
        const { formatMessage } = this.props.intl;
        const { saving, locationName, ...toggleState } = this.state;
        const loading = settingData?.loading;

        return (
            <Loader type="page" show={loading}>
                <div className={cx(s.widthInner, s.space5)}>
                    <Form onSubmit={this.handleSubmit}>
                        <Row className={cx('mb-4', s.headerRow)}>
                            <Col xs="auto">
                                <Link to="/siteadmin/location" className="btn btn-light">
                                    <FaChevronLeft className='mr-2' />
                                    <FormattedMessage {...messages.goBack} />
                                </Link>
                            </Col>
                            <Col className="text-center">
                                <h4 className={cx('mb-0', s.pageTitle)}>
                                    <FormattedMessage {...messages.serviceSettingsFor} />
                                    {locationName ? ` ${locationName}` : ''}
                                </h4>
                            </Col>
                            <Col xs="auto">
                                <button
                                    type="submit"
                                    disabled={saving}
                                    className={cx('btn btn-danger')}
                                >
                                    <FormattedMessage {...messages.saveSetting} />
                                </button>
                            </Col>
                        </Row>

                        <Row>
                            {SERVICE_GROUPS.map(({ titleKey, descKey, services }) => (
                                <Col lg={6} md={6} sm={12} xs={12} key={titleKey} className="mb-4">
                                    <Card className={s.serviceCard}>
                                        <Card.Body>
                                            <h5 className={s.cardTitle}>
                                                <FormattedMessage {...messages[titleKey]} />
                                            </h5>
                                            <p className={'text-muted text-sm'}>
                                                <FormattedMessage {...messages[descKey]} />
                                            </p>
                                            <div className={s.toggleList}>
                                                {services.map(({ key, labelKey }) => (
                                                    <Form.Check
                                                        key={key}

                                                        type="switch"
                                                        id={`switch-${key}`}
                                                        label={formatMessage(messages[labelKey])}
                                                        checked={toggleState[key]}
                                                        onChange={() => this.handleToggle(key)}
                                                        className={s.toggleItem}
                                                    />
                                                ))}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Form>
                </div>
            </Loader>
        );
    }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { updateLocationServiceSetting };

export default withStyles(s)(injectIntl(connect(mapStateToProps, mapDispatchToProps)(LocationServiceSettings)));
